import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../SponsorsPage';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import RodapeLP from '../Home/modules/RodapeLP';
import Whatsapp from '../../components/Whatsapp';
import { ContactIcons } from 'src/components/MenuOld';
import { getYear } from 'date-fns';

const FooterLayout: React.FC = ({ children }) => {
  return (<><div style={{ zIndex: 0, display: 'block' }}>

    {/* <ImageSliderBackground slides={['/apoio/fundo1.jpg', '/apoio/fundo2.jpg', '/apoio/fundo3.jpg']} /> */}
    <div style={{ width: '100%', borderTop: '5px solid #c60a0a', marginTop: '-3px' }} />

    <div tabIndex={0} className='gap-bg column ' style={{ position: 'relative', minHeight: '10vh', padding: '0px 15px', background: '#fff', zIndex: 900000 }}>

      <div className='full-width ' style={{ zIndex: 1 }}>


        <Sponsors />

      </div>



    </div>

    <div className='row-to-column max-1400 full-width' style={{ zIndex: 2, position: 'relative', justifyContent: 'space-between', margin: '15px auto', paddingBottom: '10px' }}>
      <p style={{ color: '#fff', fontSize: '14px', padding: '10px' }} className="text-center-mobile">{getYear(new Date())} - © Expoagas 2024 - Todos os direitos reservados.</p>
      <ContactIcons color="#fff" />
    </div>
  </div>

  </>
  );
};

export default FooterLayout;
